<template>
    <v-dialog v-model="show" width="600" persistent no-click-animation>
        <v-card>
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{$t(campaign ? 'updateCampaign' : 'createCampaign') | capitalizeAll}}</div>
                    <v-btn flat icon @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-form v-model="formValid" @submit="submit" ref="form">
                    <v-text-field
                        v-model="model.title"
                        :label="$filters.capitalize($t('name'))"
                        :rules="formRules.required"
                    ></v-text-field>
                    <v-text-field
                        v-model="model.tel_number"
                        :label="$filters.capitalize($t('phone'))"
                        :rules="[formRules.ruleRequired, formRules.rulePhone]"
                    ></v-text-field>
                    <v-layout row>
                        <v-flex xs6 class="pr-2">
                            <DateTimePicker
                                v-model="model.start_date"
                                :label="$filters.capitalize($t('from'))"
                                :rules="[formRules.ruleRequired, formRules.ruleDateTime]"
                                :disabled="!!campaign"
                                icon-end="event"
                            ></DateTimePicker>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <DateTimePicker
                                v-model="model.end_date"
                                :label="$filters.capitalize($t('to'))"
                                :min="model.start_date"
                                :rules="[formRules.ruleRequired, formRules.ruleDateTime]"
                                :disabled="!!campaign"
                                icon-end="event"
                            ></DateTimePicker>
                        </v-flex>
                    </v-layout>
                    <v-select
                        v-model="model.direction"
                        :items="directionData"
                        :label="$filters.capitalize($t('direction'))"
                    ></v-select>
                    <v-text-field
                        v-model="model.script"
                        :label="$filters.capitalize($t('script'))"
                        :rules="[formRules.ruleRequired]"
                    ></v-text-field>
                    <!--
                    <v-text-field
                        v-model="model.schedule"
                        :label="$filters.capitalize($t('schedule'))"
                        :rules="[formRules.ruleRequired]"
                    ></v-text-field>
                    -->
                    <v-text-field
                        v-model="model.description"
                        :label="$filters.capitalize($t('note'))"
                    ></v-text-field>
                    <br>
                    <h3>{{$filters.capitalize($t('dataCollectionMapping'))}}</h3>
                    <div class="dynamic-fields">
                        <template v-if="data_collection_mapping_TMP.length">
                            <div class="field" v-for="(field, index) in data_collection_mapping_TMP" :key="field.key">
                                <v-layout row>
                                    <v-flex xs6 class="pr-2">
                                        <v-text-field
                                            v-model="data_collection_mapping_TMP[index].prop"
                                            :label="$filters.capitalize($t('key'))"
                                            :rules="formRules.required"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 class="pl-2">
                                        <v-text-field
                                            v-model="data_collection_mapping_TMP[index].title"
                                            :label="$filters.capitalize($t('title'))"
                                            :rules="formRules.required"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <div class="act-remove">
                                    <v-btn class="ma-0" depressed small @click="removeCollectionData(index)">
                                        <v-icon>mdi-window-close</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </template>
                        <div class="act-add">
                            <v-btn class="ma-0" color="primary" depressed flat @click="addCollectionData()">
                                <v-icon left dark>mdi-plus-circle-outline</v-icon>
                                Add New
                            </v-btn>
                        </div>
                    </div>
                    <br>
                    <br>
                    <v-layout>
                        <v-flex xs6 class="pr-2">
                            <v-btn
                                style="width: 100%"
                                class="ma-0"
                                @click="close"
                            >
                                Cancel
                            </v-btn>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <v-btn
                                style="width: 100%"
                                class="ma-0"
                                type="submit"
                                color="primary"
                            >
                                {{campaign ? $t('update') : $t('create')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import DateTimePicker from '@/components/DateTimePicker'
import CampaignService from '@/services/campaign.service'

export default {
    name      : 'CampaignEditor',
    components: { DateTimePicker },
    mixins    : [FormMixin],
    props     : {
        onSaved: Function
    },
    data() {
        return {
            formValid                  : false,
            show                       : false,
            directionData              : ['INBOUND', 'OUTBOUND'],
            model                      : {
                owner                  : '',
                title                  : '',
                description            : '',
                start_date             : '',
                end_date               : '',
                tel_number             : '',
                direction              : '',
                script                 : '',
                schedule               : '',
                status                 : '',
                data_collection_mapping: ''
            },
            data_collection_mapping_TMP: [],
            campaign                   : null
        }
    },
    methods   : {
        open(campaign) {
            this.show = true
            this.$refs.form.resetValidation()
            if (campaign) {
                this.campaign                      = campaign
                this.model.owner                   = campaign.owner
                this.model.title                   = campaign.title
                this.model.description             = campaign.description
                this.model.tel_number              = campaign.tel_number
                this.model.direction               = campaign.direction
                this.model.script                  = campaign.script
                this.model.schedule                = campaign.schedule
                this.model.status                  = campaign.status
                this.model.start_date              = this.$filters.formatDateTime(campaign.start_date)
                this.model.end_date                = this.$filters.formatDateTime(campaign.end_date)
                this.model.data_collection_mapping = campaign.data_collection_mapping
                this.$nextTick(() => {
                    this.prepareCollectionData()
                })
            } else {
                this.campaign = null;
                this.resetModel()
            }
        },
        close() {
            this.show = false
            this.resetModel()
            this.$refs.form.reset()
        },
        addCollectionData() {
            this.data_collection_mapping_TMP.push({
                prop : '',
                title: ''
            })
        },
        removeCollectionData(index) {
            this.data_collection_mapping_TMP.splice(index, 1)
        },
        prepareCollectionData() {
            if (this.model.data_collection_mapping !== '' || Object.keys(this.model.data_collection_mapping).length) {
                let obj = JSON.parse(this.model.data_collection_mapping)
                let arr = []
                for (let k in obj) {
                    if (obj.hasOwnProperty(k)) {
                        arr.push({
                            prop : k.toString(),
                            title: obj[k].toString()
                        })
                    }
                }
                this.data_collection_mapping_TMP = arr
            }
        },
        convertCollectionData() {
            let obj = {}
            if (this.data_collection_mapping_TMP.length) {
                let data = this.data_collection_mapping_TMP
                for (let i = 0; i < data.length; i++) {
                    obj[data[i]['prop']] = data[i]['title']
                }
            }
            this.model.data_collection_mapping = JSON.stringify(obj)
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            this.convertCollectionData()
            if (this.formValid) {
                let i18n      = {
                    action: this.campaign ? this.$t('update') : this.$t('create'),
                    item  : this.$t('campaign')
                }
                const promise = this.campaign
                    ? CampaignService.CRUD.update(this.campaign, this.model)
                    : CampaignService.createCampaign(this.model)
                if (this.model.owner === '') {
                    this.model.owner = this.$store.state.user.profile.email
                }
                promise.then(
                    result => {
                        this.show = false
                        this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                        if (this.onSaved) {
                            this.onSaved()
                        }
                        this.$nextTick(() => this.$refs.form.reset())
                    })
            } else {
                this.$refs.form.validate()
            }
        },
        resetModel() {
            this.model                       = {
                owner                  : '',
                title                  : '',
                description            : '',
                tel_number             : '',
                direction              : '',
                script                 : '',
                schedule               : '',
                status                 : '',
                start_date             : '',
                end_date               : '',
                data_collection_mapping: ''
            }
            this.data_collection_mapping_TMP = []
        }
    }
}
</script>

<style scoped>

</style>
